import React from 'react';
import {Switch,FormGroup,FormControlLabel} from '@material-ui/core/';
import IntlMessages from 'util/IntlMessages';
function LopandeInput(props) {
    const [Value,setValue] = React.useState(props.Lopande===1?true:false)
    const onchangeHandle=(e)=>{
        setValue(e.target.checked)
        props.onchangeHanelEvent("Lopande",e.target.checked===false?0:1)
    }
    return (
        <FormGroup row>

            <FormControlLabel
            control={
                <Switch
                checked={Value}
                onChange={onchangeHandle}
                name="Lopande"
                color="primary"
            />
            }
            label={<IntlMessages id="OnGoing"/>}
            />
      </FormGroup>
    );
}

export default LopandeInput;